import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import ScrollToTop from "./components/ScrollToTop";
import "@/App.css";

// Public Pages
import HomePage from "./pages/HomePage";
import ToursPage from "./pages/ToursPage";
import TourDetailPage from "./pages/TourDetailPage";
import ReservationPage from "./pages/ReservationPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTours from "./pages/admin/AdminTours";
import AdminTourForm from "./pages/admin/AdminTourForm";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminMedia from "./pages/admin/AdminMedia";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors />
        <WhatsAppFloatingButton />
        <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/excursiones" element={<ToursPage />} />
        <Route path="/tour/:slug" element={<TourDetailPage />} />
        <Route path="/reservar" element={<ReservationPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="tours" element={<AdminTours />} />
          <Route path="tours/new" element={<AdminTourForm />} />
          <Route path="tours/:id/edit" element={<AdminTourForm />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="reviews" element={<AdminReviews />} />
        </Route>
      </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
